<template>
    <div>
        <v-combobox
            :label="label"
            :disabled="disabled"
            :items="$system.tags"
            chips
            hide-selected
            return-object
            item-title="name"
            item-value="id"
            max
            multiple
            v-model="tags"
            @update:modelValue="assignTag"
        >
            <template #chip="{ item, props }">
                <v-chip @click:close="removeTag(item.raw)" class="ma-1" size="default" color="primary" :closable="!disabled" v-bind="props">
                </v-chip>
            </template>
        </v-combobox>
    </div>
</template>
<script>
export default {
    props: {
        modelValue: {
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: null
        },
        id: {
            type: [Number, String],
            default: 0
        },
    },
    computed: {
        tags: {
            get: function () {return this.type ? this.modelValue : this.$system.tags},
            set: function (value) {this.type ? this.$emit('update:modelValue', value) : null}
        },
    },
    methods: {
        async assignTag(value) {
            if (value.length > this.tags.length) {
                let tag = value.at(-1);
                if (typeof tag == 'string') {
                    await this.$system.createTag(tag);
                    if (!this.type)
                        return;
                    tag = this.$system.tags.find(x => x.name == tag);
                    value.splice(value.length - 1, 1);
                    value[value.length] = tag;
                }
                if (tag)
                    this.$assignTag(tag.id, {taggable_type: this.type, taggable_id: this.id});
            }
        },
        removeTag(tag) {
            if (this.type) {
                this.$removeTag(tag.id, {taggable_type: this.type, taggable_id: this.id});
                this.tags.splice(this.tags.findIndex(x => x.id == tag.id), 1);
            }
            else
                this.$system.deleteTag(tag.id);
        },
    },
    async created() {
        await this.$system.setTags();
    }
}
</script>
